import { leaderboardClient } from '@neptune/shared/core-apis-leaderboard-domain';
import {
  convertPaginationFromDomainToApi,
  convertSortingFromDomainToApi,
  Leaderboard,
  leaderboardFromApiToDomain,
  LeaderboardPagination,
  LeaderboardSortingParams,
} from '@neptune/shared/leaderboard-domain';

export type SearchMyRunsRequest = {
  query: string;
  username?: string;
  experimentsOnly?: boolean;
  experimentRegex?: string;
  sorting?: LeaderboardSortingParams;
  pagination: LeaderboardPagination;
};

export async function searchMyRuns({
  query,
  username,
  experimentsOnly,
  sorting: domainSorting,
  pagination: domainPagination,
}: SearchMyRunsRequest): Promise<Leaderboard> {
  const sorting = (domainSorting && convertSortingFromDomainToApi(domainSorting)) ?? undefined;
  const pagination = domainPagination && convertPaginationFromDomainToApi(domainPagination);

  const result = await leaderboardClient.searchUserRuns({
    params: {
      username,
      query: { query },
      pagination,
      sorting,
      experimentLeader: experimentsOnly,
    },
  });

  return leaderboardFromApiToDomain(result);
}
